<template>
	<div class="case-infograf">
		<b-row class="item-container" no-gutters v-for="(item, index) in filteredInfographs()" :key="index">
			<b-col cols="12" md="3" class="d-flex align-items-stretch">
				<div class="item-red d-flex flex-row flex-md-column justify-content-start align-items-center">
					<img :src="item.service_link.img.url" alt="">
					<p class="ttl">{{item.service_link.title}}</p>
				</div>
			</b-col>
			<b-col cols="12" md="3" class="itemcont" v-for="(info, i) in item.infograph_item" :key="i">
				<div class="item d-flex flex-row flex-md-column justify-content-start align-items-center">
					<p class="subttl">{{info.title}}</p>
					<p class="num">{{info.text}}</p>
					<p class="description">{{info.text2}}</p>
				</div>
			</b-col>
		</b-row>
	</div>
</template>

<script>
	//const axios = require('axios');
	export default {
		props: {
			data: Array,
		},
		data() {
			return {}
		},
		methods: {
			filteredInfographs() {
				const items = this.data;

				return items.reduce((acc, element) => {
					if (this.$route.query.serv === element.service_link.title) {
						return [element, ...acc];
					}
					return [...acc, element];
				}, []);
			},
		}
	}
</script>

<style lang="scss" scoped>
	
	.case-infograf {
		cursor: n-resize;
		max-height: 387px;
		overflow-y: scroll;
		overflow-x: visible;
		text-align: center;
		
		&::-webkit-scrollbar {
			width: 10px;
		}
		
		@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
			padding-right: 15px;
		}
		
		
		.item-container {
			background-color: #ffffff;
			border-radius: 0 6px 6px 0;
			padding: 0;
			overflow: hidden;
			
			&:hover {
				
				.itemcont {
					.num, .description {
						color: $activeColor;
					}
				}
			}
			
			@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
				border-radius: 0 0 10px 10px;
			}
			
			&:not(:last-child) {
				margin-bottom: 16px;
			}
			
			.item-red {
				width: 100%;
				padding-top: 15px;
				background-color: #D14647;
				border-radius: 6px 0 0 6px;
				box-shadow: 0px 4px 24px rgba(209, 70, 71, 0.65);
				@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
					padding: 15px;
					box-shadow: 0px 4px 24px rgba(209, 70, 71, 0.65);
					border-radius: 10px 10px 0 0;
				}
				
				img {
					margin-bottom: 13px;
					width: 55px;
					@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
						margin: 0;
						width: 37px;
					}
				}
				
				.ttl {
					margin-bottom: 15px;
					font-weight: 500;
					font-size: 16px;
					line-height: 100%;
					text-decoration-line: underline;
					color: #FFFFFF;
					@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
						margin: 0;
						margin-left: 15px;
						font-size: 18px;
					}
				}
			}
			
			.itemcont {
				&:last-child .item {
					@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
						padding-bottom: 15px;
					}
				}
			}
			
			.item {
				padding: 18px 10px 0 10px;
				padding-bottom: 5px;
				word-break: break-word;
				@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
					flex-wrap: wrap;
					padding: 15px 10px 0px 10px;
					
				}
				
				.subttl {
					font-weight: 500;
					font-size: 16px;
					line-height: 100%;
					color: $secondFontColor;
				
					
					@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
						width: 100%;
						text-align: left;
						font-size: 14px;
					}
				}
				
				.num {
					font-weight: 700;
					font-size: 26px;
					color: $mainFontColor;
					transition: all 0.3s ease-in-out;
					
					@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
						font-size: 16px;
						margin-right: 5px;
					}
				}
				
				.description {
					font-weight: 700;
					font-size: 16px;
					color: $mainFontColor;
					transition: all 0.3s ease-in-out;
				}
			}
		}
	}

</style>